"use client"

import { useNetworkStatus } from "@/hooks/use-network-status"
import { AlertCircle, Wifi, WifiOff } from "lucide-react"
import { Alert, AlertDescription, AlertTitle } from "./alert"

/**
 * Network status indicator component
 * Shows when user is offline or has a slow connection
 * Hidden in development mode as it's not relevant during development
 */
export function NetworkStatusIndicator() {
  const { isOnline, isSlowConnection } = useNetworkStatus()

  // Don't show in development mode
  if (process.env.NODE_ENV === 'development') {
    return null
  }

  if (isOnline && !isSlowConnection) {
    return null // Don't show anything when online with good connection
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md">
      <Alert 
        variant={isOnline ? "default" : "destructive"}
        className="bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700"
      >
        <div className="flex items-center gap-2">
          {isOnline ? (
            <Wifi className="h-4 w-4" />
          ) : (
            <WifiOff className="h-4 w-4" />
          )}
          <AlertTitle>
            {isOnline ? "Slow Connection" : "You're Offline"}
          </AlertTitle>
        </div>
        <AlertDescription>
          {isOnline
            ? "Your connection is slow. Some features may be limited."
            : "You're currently offline. Some features may not work until you reconnect."}
        </AlertDescription>
      </Alert>
    </div>
  )
}





